import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";

export class FormModel {
    // Data to save a form in a database
    dbId?: number;
    name: string = 'Unnamed Form';
    customerId?: string;
    formTypeId?: number;        // Underwriting, Risk,...

    // Usually not there
    // Coming from FormVersion
    createdBy?: string;
    created: string = '';       // DB: Stored as "2022-08-15T16:35:36.120Z"
    dbParentId?: number;
    statusId: number = 1;       // Draft, Approved,...
    serviceCode?: string;

    //TODO:check after api is done

    toJSON(): any {
        let toJsonObject = {
            // stringify ignores undefined
            Name: this.name,
            FormTypeId: this.formTypeId,
            Created: this.created,
            DbParentId: this.dbParentId
        };

        // Optional undefined fields should not be printed
        if (this.dbId !== undefined) {
            toJsonObject['DbId'] = this.dbId;
        }
        if (this.customerId !== undefined) {
            toJsonObject['CustomerId'] = this.customerId;
        }
        if (this.formTypeId !== undefined) {
            toJsonObject['FormTypeId'] = this.formTypeId;
        }
        if (this.dbParentId !== undefined) {
            toJsonObject['DbParentId'] = this.dbParentId;
        }
        if (this.createdBy !== undefined) {
            toJsonObject['CreatedBy'] = this.createdBy;
        }
        if (this.serviceCode !== undefined) {
            toJsonObject['ServiceCode'] = this.serviceCode;
        }
        return toJsonObject;
    }

    /**
     * Clone this node from an origin.
     * @note Without children.
     * @param origin
     * @returns the cloned node
     */
    cloneFrom(origin: any): FormModel {

        if (origin.Id) {
            this.dbId = origin.Id;
        }
        this.name = origin.name;
        if (origin.CustomerId) {
            this.customerId = origin.CustomerId;
        }
        if (origin.FormTypeId) {
            this.formTypeId = origin.FormTypeId;
        }

        if (origin.CreatedBy) {
            this.createdBy = origin.CreatedBy;
        }
        if (origin.Created) {
            this.created = origin.Created;
        }
        if (origin.DbParentId) {
            this.dbParentId = origin.DbParentId;
        }
        if (origin.StatusId) {
            this.statusId = origin.StatusId;
        }
        if (origin.ServiceCode) {
            this.serviceCode = origin.ServiceCode;
        }
        
        // Don't clone FormVersions !!!!
        return this;
    }
}